import styled from "styled-components"

const ToggleWrapper = styled.div`
  width: 50px;
  height: 25px;
  border-radius: 25px;
  display: flex;
  background: ${(p) => p.theme.bodyFontColor};
  margin: auto 0 auto auto;
`
const Notch = styled.div`
  width: 21px;
  height: 21px;
  border: 1px solid #eee;
  margin-top: 1px;
  background: ${(p) => p.theme.bodyBackgroundColor};
  border-radius: 50%;
  transition: transform 0.1s linear;
  transform: translate(${(p) => (p.isActive ? "26px" : "1px")});
`

export function Toggle({ isActive, onToggle }) {
  return (
    <ToggleWrapper onClick={onToggle}>
      <Notch isActive={isActive} />
    </ToggleWrapper>
  )
}
